import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { login, UpdateLoginFallos, GetLoginFallos } from "../services/auth";
import Constants from "../utils/constants";
import Select from "./common/Select";
import { useAPIs } from "../apis/APIsConfig";
import { useForm } from "../utils/hooks";
import WithLoginLayout from "../hocs/layouts/LoginLayout";
import InputMask from "react-input-mask";
import { useGlobalStore } from "../utils/global";
import { getObtenerValorPorCodigo } from "../services/parameters";

function Login() {
  useAPIs();
  const navigate = useNavigate();
  const [passwordShown, setPasswordShown] = useState(false);

  const { updateUser, updateBPMSActive, showNotification } = useGlobalStore(); 
  const [formState, setError, changeHandler, reset] = useForm({
    type: "P",
    username: "",
    password: "",
  });
  const [citaUrl, setCitaUrl] = useState(
    process.env.REACT_APP_CITA_URL || ""
  );

  useEffect(() => {
    updateUser(null);
  }, []);

  useEffect(() => {
    let cancelled = false;

    getObtenerValorPorCodigo(Constants.AGENDA_TU_CITA)
      .then((ans) => {
        const valor = ans?.data?.value?.valor;
        const estado = ans?.data?.value?.estado;
        if (
          !cancelled &&
          ans?.data?.successed &&
          estado === true &&
          typeof valor === "string" &&
          valor.trim()
        ) {
          setCitaUrl(valor.trim());
        }
      })
      .catch((error) => {
        console.log("Error fetching AGENDA_TU_CITA:", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  function disableButton() {
    return formState.data.username.replaceAll("_", "").length !== 11 || !formState.data.password;
  }

  function submitForm() {
    var maxFailedAttempts = 3;//Default in case Constants.MAX_LOGIN_INTENTOS is null.
    // Step 1: Check login failures
    GetLoginFallos(formState.data.username)
      .then((failResponse) => {
        if (!failResponse.data.successed) {
          console.log("No se pudo obtener información sobre intentos de inicio de sesión.");
        }
        
        var maxFailedAttempts = 3;
        const { failedAttempts, timeleft } = failResponse.data.value;
        
        return getObtenerValorPorCodigo(Constants.MAX_LOGIN_INTENTOS)
          .then((ans) => {
            if (ans?.data?.successed) {
              maxFailedAttempts = ans.data.value.valor;
            }
          })
          .catch((error) => {
            console.log("Error fetching MAX_LOGIN_INTENTOS status:", error);
          })
          .then(() => ({ failedAttempts, timeleft })); 

      })
      .then(({ failedAttempts, timeleft }) => {
        if (failedAttempts >= maxFailedAttempts && timeleft > 0) {
          showNotification({
            title: "Error",
            message: `Número máximo de intentos alcanzado. Intenta en ${timeleft} minutos.`,
            isError: true,
          });
          return Promise.reject("Maximum login attempts reached.");
        }

        // Step 2: Attempt login
        return login(formState.data);
      })
      .then((loginResponse) => {
        if (!loginResponse || !loginResponse.data) {
          // Handle failed login - Only call UpdateLoginFallos once here
          return UpdateLoginFallos(formState.data.username, false).then(() => {
            console.log("Usuario o contraseña inválido");
            return Promise.reject("Invalid username or password.");
          });
        }

        // Successful login (cedula for Plan Complementario / Unipago API)
        const cedula = formState.data.username.replaceAll("_", "").trim();
        const user = { token: loginResponse.data.value, cedula };
        updateUser(user);

        // Reset login failures
        return UpdateLoginFallos(formState.data.username, true)
          .catch((error) => console.log("Error reseteando intentos de inicio de sesión:", error));
      })
      .then(() => {
        // Fetch BPMS activation status and update global state
        return getObtenerValorPorCodigo(Constants.ACTIVAR_BPMS_BENEFICIO)
          .then((ans) => {
            const isActive = ans?.data?.successed && ans.data.value.estado;
            updateBPMSActive(isActive || false);
          })
          .catch((error) => {
            console.log("Error fetching BPMS status:", error);
            updateBPMSActive(false);
          });
      })
      .then(() => {
        // Handle BPMS tasks or navigate to dashboard
        const bpmsTasks = JSON.parse(localStorage.getItem(Constants.BPMS_TASKS) || "null");
        if (bpmsTasks) {
          window.open(bpmsTasks, "_self");
        } else {
          navigate(Constants.APPURLS.DASHBOARD);
        }
      })
      .catch((error) => {
        if (error === "Maximum login attempts reached." || error === "Invalid username or password.") {
          return; // Do nothing to prevent double UpdateLoginFallos
        }
        
      });
}

  

  return (
    <>
      <div className="block pb-8 lg:pb-10">
        <p className="text-gray-70 lead font-body font-semibold">
          Bienvenido a la
        </p>
        <h1 className="text-primary-100 font-bold">Oficina Virtual</h1>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className="block space-y-6 lg:space-y-8 w-full pb-6 lg:pb-10 mb-0 lg:mb-10 border-b-0 lg:border-b border-gray-10"
      >
        <div className="form-group">
          <label>Documento de Identidad</label>
          <InputMask
            type="text"
            className="form-control large"
            placeholder="Ingresa tu documento"
            value={formState.data.username}
            onChange={changeHandler("username", undefined, "-")}
            mask="999-9999999-9"
            maskPlaceholder={"_"}
          />
        </div>
        <div className="form-group">
          <label>Contraseña</label>
          <div className="form-icon">
            <i
              onClick={togglePassword}
              className={`icon icon-eye${passwordShown ? "" : "off"
                } right text-gray-80 icon-password text-[10px]`}
            ></i>
            <input
              id="Password"
              type={passwordShown ? "text" : "password"}
              className="form-control large"
              placeholder="Ingresa tu contraseña"
              value={formState.data.password}
              onChange={changeHandler("password")}
            />
          </div>
          <Link
            to={Constants.APPURLS.RECOVER_PASSWORD}
            className="flex justify-end pt-4 text-primary-100 text-body-2 font-body font-normal"
          >
            ¿Olvidaste tu contraseña?
          </Link>
        </div>
        <button
          type="button"
          className="btn btn-primary btn-large w-full"
          disabled={disableButton()}
          onClick={submitForm}
        >
          Ingresar
        </button>
        {
          <div className="text-center">
            <Link
              to={Constants.APPURLS.SIGNUP}
              className="text-gray-70 text-body-1 font-body font-normal"
            >
              ¿Aún no tienes cuenta?{" "}
              <span className="text-primary-100 font-semibold"> Regístrate</span>
            </Link>
          </div>
        }
      </form>

      <div className="grid grid-cols-2 gap-4">
        <Link to={Constants.APPURLS.CALCULATORS} className="card-setting">
          <i className="icon icon-calculator"></i>
          <h5>Calculadoras</h5>
        </Link>
        <a href={process.env.REACT_APP_BENEFICIOS_URL} className="card-setting">
          <i className="icon icon-cashv2"></i>
          <h5>Beneficios</h5>
        </a>
        <a href={citaUrl} className="card-setting">
          <i className="icon icon-inquiry"></i>
          <h5>Solicitar Cita</h5>
        </a>
        <a
          href={process.env.REACT_APP_CONTACTANOS_URL}
          className="card-setting"
        >
          <i className="icon icon-chat"></i>
          <h5>Contáctanos</h5>
        </a>
      </div>
    </>
  );
}

export default WithLoginLayout(Login, true);
